<template>
    <div class="podcast-card">
        <div class="podcast-card__cover podcast-cover">
            <router-link :to="`/podcasts/${podcast.id}`">
                <img class="podcast-cover__img" :src="podcast.cover" :alt="podcast.name" />
                <span v-if="podcast.is_explicit" class="podcast-cover__badge">
                    {{ $t('podcasts.card.explicit') }}
                </span>
            </router-link>
        </div>
        <div class="podcast-card__detail">
            <router-link :to="`/podcasts/${podcast.id}`" class="podcast-card__title">
                {{ podcast.name }}
            </router-link>
            <div class="podcast-card__author">{{ podcast.author }}</div>
            <div class="podcast-card__categories">
                <span class="podcast-card__category">{{ podcast.categories.value }}</span>
            </div>
            <div class="podcast-card__description">{{ podcast.description }}</div>
            <div class="podcast-card__actions">
                <button
                    type="button"
                    class="button button--gray podcast-card__action podcast-card__feed"
                    @click="copyRssFeed"
                >
                    {{ $t('podcasts.copyFeed') }}
                </button>
                <PodcastDeleteModal :podcast="podcast" @deleted="handleDelete" />
            </div>
        </div>
    </div>
</template>

<script>
import { copyToClipboard } from '@speechki-frontend/shared/helpers/functions';
import PodcastDeleteModal from '../PodcastDeleteModal/PodcastDeleteModal';

export default {
    name: 'PodcastCard',
    components: { PodcastDeleteModal },
    props: {
        podcast: {
            type: Object,
            required: true,
        },
    },
    methods: {
        handleDelete(podcast) {
            this.$emit('deleted', podcast);
        },
        copyRssFeed() {
            copyToClipboard(this.podcast.feed_url);
            this.$store.dispatch('pushToast', {
                id: Date.now(),
                type: 'success',
                title: this.$t('podcasts.copyFeedSuccess'),
            });
        },
    },
};
</script>

<style lang="scss" src="./PodcastCard.scss"></style>
